import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { isValidElement, Children, cloneElement } from 'react';

const MuiGrid = props => {
    const { children, ...restProps } = props;

    return (
        <Grid container style={{ width: '100%' }} {...restProps}>
            {Children.map(children, (child, index) => {
                if (!isValidElement(child)) return child;

                const { gridProps, ...restChildProps } = child.props;

                if (!gridProps) return child;

                return (
                    <Grid {...gridProps} key={child.key || index}>
                        {cloneElement(child, restChildProps)}
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default MuiGrid;
